import React, { useState } from 'react';

function LoginModal({ onClose, onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('admin');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock validation - replace with API call
    if (email && password) {
      onLogin(role);
    }
  };

  return (
    <div className="login-overlay" onClick={onClose}>
      <div className="login-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>✕</button>
        <div className="login-header">
          <span className="login-icon">🏫</span>
          <h2>Welcome Back</h2>
          <p>Access your institute dashboard</p>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="user@institute.edu" />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••" />
          </div>
          <div className="form-group">
            <label>Login As</label>
            <select value={role} onChange={e => setRole(e.target.value)}>
              <option value="admin">Admin / Director / Principal</option>
              <option value="teacher">Teacher / Staff</option>
              <option value="student">Student</option>
              <option value="parent">Parent</option>
            </select>
          </div>
          <button type="submit" className="btn btn-primary login-submit">Sign In →</button>
        </form>
        <div className="login-footer">
          <p>Demo: Use any email & password to login</p>
        </div>
      </div>
    </div>
  );
}

export default LoginModal;